$.extend(true, $.magnificPopup.defaults, {
    tClose:'Schlie' + unescape("%DF") + 'en (Esc)', // Alt text on close button
    tLoading:'Ladet...',
    gallery:{
        tPrev:'Previous (Left arrow key)', // Alt text on left arrow
        tNext:'Next (Right arrow key)', // Alt text on right arrow
        tCounter:'%curr% / %total%' // Markup for "1 of 7" counter
    },
    image:{
        tError:'<a href="%url%">The image</a> could not be loaded.' // Error message when image could not be loaded
    },
    ajax:{
        tError:'<a href="%url%">The content</a> could not be loaded.' // Error message when ajax request failed
    }
});